module.exports = __webpack_public_path__ + "images/135_320.jpg";